import { getAuthUserInfo } from '@/services/user/auth';

type InitialStateUpdater = (
  updater: (state: Record<string, unknown>) => Record<string, unknown>,
) => void;

let setInitialStateFn: InitialStateUpdater | null = null;
let syncUserPromise: Promise<void> | null = null;

export const registerInitialStateSetter = (fn: InitialStateUpdater | null) => {
  setInitialStateFn = fn;
};

/** token 刷新后同步顶部导航等依赖的 currentUser */
export const syncCurrentUserToInitialState = async (): Promise<void> => {
  if (!setInitialStateFn) {
    return;
  }

  if (!syncUserPromise) {
    syncUserPromise = (async () => {
      try {
        const userInfo = await getAuthUserInfo({ skipErrorHandler: true });
        if (!userInfo) {
          return;
        }
        setInitialStateFn?.((state) => ({
          ...state,
          currentUser: userInfo,
        }));
      } catch {
        // 忽略同步失败，原请求重试仍会继续
      } finally {
        syncUserPromise = null;
      }
    })();
  }

  return syncUserPromise;
};
